import { memo } from 'react';
import { StyledSimpleCard } from 'styles';
import { ReactivateDiscardedTeamForm } from '../DataManagement/components/ReactivateDiscardedTeamForm';

const ReactivateDiscardedTeamCard = () => {
  return (
    <StyledSimpleCard>
      <ReactivateDiscardedTeamForm />
    </StyledSimpleCard>
  );
};

export default memo(ReactivateDiscardedTeamCard);
